/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Name_TakenInputs */

const en_statement_taxonomy_name_taken = /** @type {(inputs: Statement_Taxonomy_Name_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An active classification template already uses that name`)
};

const nl_statement_taxonomy_name_taken = /** @type {(inputs: Statement_Taxonomy_Name_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er bestaat al een actief classificatiesjabloon met die naam`)
};

/**
* | output |
* | --- |
* | "An active classification template already uses that name" |
*
* @param {Statement_Taxonomy_Name_TakenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_name_taken = /** @type {((inputs?: Statement_Taxonomy_Name_TakenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Name_TakenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_name_taken(inputs)
	return en_statement_taxonomy_name_taken(inputs)
});